import page from "@/styles/modules/page.module.scss";
import * as Api from "@api";
import { Typography, typographyClass } from "@components";
import clsx from "clsx";
import React from "react";



export interface PageContentProps extends Api.ContentItem
{
    centered?: boolean;
    className?: string;
    marginBottom?: number;
    typography?: Typography;
    uppercase?: boolean;
    width?: number;
}

export const PageContent = ({ centered, className, data, marginBottom, type, typography, uppercase, width }: PageContentProps): React.FunctionComponentElement<PageContentProps> =>
{

    const cn = {
        className: clsx(
            typographyClass(typography),
            className
        ),
        style: {
            marginBottom: marginBottom !== undefined ? `${marginBottom}px` : undefined,
            textAlign: centered ? "center" : undefined,
            textTransform: uppercase ? "uppercase" : undefined,
            width: width !== undefined ? `${width}px` : undefined,
        } satisfies React.CSSProperties
    };

    return type === Api.ContentType.Html ?
        <div {...cn} dangerouslySetInnerHTML={{ __html: data }} />
        :
        typography === Typography.H1 ? <h1 {...cn}>{data}</h1> :
            typography === Typography.H2 ? <h2 {...cn}>{data}</h2> :
                typography === Typography.H3 ? <h3 {...cn}>{data}</h3> :
                    typography === Typography.H4 ? <h4 {...cn}>{data}</h4> :
                        typography === Typography.H5 ? <h5 {...cn}>{data}</h5> :
                            typography === Typography.H6 ? <h6 {...cn}>{data}</h6> :
                                <p {...cn}>{data}</p>;
}

interface PageSectionProps extends React.ComponentProps<"section"> 
{
    large?: boolean;
}

export const PageSection = ({ className, large, ...props }: PageSectionProps): React.ReactComponentElement<"section", PageSectionProps> =>
{
    return <section {...props} className={clsx(page.page__section, { "large": large }, className)} />;
}

interface PageProps extends React.ComponentProps<"div"> { }

export const Page = ({ className, ...props }: PageProps): React.ReactComponentElement<"div", PageProps> =>
{
    return <div {...props} className={clsx(page.page, className)} />;
}